import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientControllerApi } from "../../services";
import { getConfigObject, getXtenantId, useBaseData } from "../../utils/utils";
import useFcmSmsCount from "../../hooks/fcm/use-fcm-sms-count";

interface Props {
  patientId?: string;
}

const useFcmSmsCountGet = ({
  patientId,
}: Props): useBaseData<{ unReadSmsCount: number }> => {
  const [_, setSmsCount] = useFcmSmsCount();

  return useQuery({
    queryKey: ["fcm-sms-count-get", patientId],
    enabled: !!patientId,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      return await new PatientControllerApi(getConfigObject())
        .getPatientUnreadSmsCount(patientId!, getXtenantId())
        .then((res: any) => {
          setSmsCount(res?.data?.data?.unReadSmsCount);

          return res?.data;
        });
    },
  });
};

export default useFcmSmsCountGet;
